/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactMemoResponseData,
  CreateContactMemoResponseDataFromJSON,
  CreateContactMemoResponseDataFromJSONTyped,
  CreateContactMemoResponseDataToJSON
} from './CreateContactMemoResponseData'

/**
 *
 * @export
 * @interface DiscardContactMemoResponse
 */
export interface DiscardContactMemoResponse {
  /**
   *
   * @type {number}
   * @memberof DiscardContactMemoResponse
   */
  status?: number
  /**
   *
   * @type {CreateContactMemoResponseData}
   * @memberof DiscardContactMemoResponse
   */
  data?: CreateContactMemoResponseData
}

export function DiscardContactMemoResponseFromJSON(json: any): DiscardContactMemoResponse {
  return DiscardContactMemoResponseFromJSONTyped(json, false)
}

export function DiscardContactMemoResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DiscardContactMemoResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateContactMemoResponseDataFromJSON(json['data'])
  }
}

export function DiscardContactMemoResponseToJSON(value?: DiscardContactMemoResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateContactMemoResponseDataToJSON(value.data)
  }
}
